// 日语
import twLocale from 'element-ui/lib/locale/lang/ja'

export default {
  ...twLocale
}
